export default from './Newsletter'